// PERSONA 5.0 — Build 01 keys
export const P5 = {
  en: {
    p5_platform: "The Intelligent Fragrance Technology Platform",
    p5_build: "Build 01 · Foundation",

    // Perfumery Tech (create research)
    p5_pt_title: "PERSONA Perfumery Tech",
    p5_pt_sub: "Discover your fragrance identity through the deterministic PERSONA Core engine.",
    p5_pt_disclaimer:
      "PERSONA Core is a deterministic engine — same identity + same versions always produces the same canonical result. The AI Perfumer never generates the official PERSONA formula.",
    p5_form_name: "Full name",
    p5_form_dob: "Date of birth",
    p5_form_blood: "Blood type",
    p5_form_gender: "Gender",
    p5_form_path: "Fragrance expression path",
    p5_form_submit: "Compute PERSONA Research",
    p5_form_computing: "Computing…",

    // Research
    p5_research_title: "My Research",
    p5_research_sub: "Your PERSONA Core research records — immutable and versioned.",
    p5_research_empty: "No research yet. Start with PERSONA Perfumery Tech.",
    p5_research_view: "View",
    p5_research_redeem: "Redeem official formula (−50 PTC)",
    p5_research_redeemed: "Formula redeemed",

    p5_research_detail: "Research Detail",
    p5_research_normalized: "Normalized identity",
    p5_research_versions: "Versions",
    p5_research_formula_vector: "Formula vector",
    p5_research_character: "Character result",
    p5_research_fingerprint: "Canonical fingerprint",

    // PTC
    p5_ptc_title: "PTC Wallet",
    p5_ptc_sub: "PERSONA Tech Credit — an append-only ecosystem loyalty ledger.",
    p5_ptc_balance: "Balance",
    p5_ptc_txns: "Transactions",
    p5_ptc_empty: "No transactions yet.",

    // Nav
    p5_nav_research: "My Research",
    p5_nav_ptc: "PTC Wallet",

    // Build 03B — Fragrance Identity & UX
    p5_fragrance_identity: "Fragrance Identity",
    p5_fragrance_identity_sub: "Legacy PERSONA fragrance routing · six-slot audited mapping",
    p5_official_formula: "Official PERSONA Formula",
    p5_formula_total: "Total",
    p5_formula_locked: "Awaiting redemption",
    p5_status_verified: "Verified",
    p5_status_verified_legacy: "Legacy PERSONA reference",
    p5_status_review_required: "Professional classification pending",
    p5_pyramid_pending: "Legacy aroma — professional classification pending",
    p5_repeat_notice: "You already have a research with this exact identity. Opening the existing record.",
    p5_month_character: "Birth-month character",
    p5_name_character: "Name character",
    p5_new_research: "New Research",

    // Build 04 — AI Perfumer × Research Interpreter
    p5_ai_title: "PERSONA AI Perfumer",
    p5_ai_subtitle: "Ask AI to interpret this research",
    p5_ai_disclaimer: "AI Interpretation only. The Official PERSONA Formula is generated exclusively by PERSONA Core — never by AI.",
    p5_ai_cta: "Ask PERSONA AI Perfumer",
    p5_ai_regenerate: "Regenerate",
    p5_ai_generating: "PERSONA AI Perfumer is composing your interpretation…",
    p5_ai_done: "AI interpretation ready",
    p5_ai_unavailable: "PERSONA AI Perfumer is temporarily unavailable.",
    p5_ai_summary: "Your Fragrance Identity",
    p5_ai_character: "Character Interpretation",
    p5_ai_identity: "Fragrance Direction",
    p5_ai_pyramid: "Pyramid Interpretation",
    p5_ai_mood: "Scent Mood",
    p5_ai_wearing: "When to Wear",
    p5_ai_perfumer_note: "Perfumer's Note",
    p5_ai_limitations: "Data Status",
    p5_ai_footer: "AI Interpretation",
    p5_ai_cached: "cached",
    p5_ai_fresh: "fresh",

    // Build 05 — Consumer UI + Unlock
    p5_research_pyramid: "Fragrance Pyramid",
    p5_birth_character: "Birth-date character",
    p5_research_not_found: "Research not found",
    p5_unlock_cta: "Unlock Full Research",
    p5_unlock_helper: "Unlock reveals the official PERSONA Formula result generated by PERSONA Core.",
    p5_unlock_soon: "Full Research unlock will be available soon.",

    // Corrective pass — unified character profile + pyramid classification pending
    p5_character_profile: "Character Profile",
    p5_character_profile_empty: "Character profile pending.",
    p5_pyramid_pending: "Classification pending",
    p5_pyramid_pending_hint: "Professional olfactive position pending for these legacy aromas.",
  },
  id: {
    p5_platform: "Platform Teknologi Wewangian Cerdas",
    p5_build: "Build 01 · Fondasi",

    p5_pt_title: "PERSONA Perfumery Tech",
    p5_pt_sub: "Temukan identitas wewangian Anda melalui engine deterministik PERSONA Core.",
    p5_pt_disclaimer:
      "PERSONA Core adalah engine deterministik — identitas + versi yang sama selalu menghasilkan hasil kanonik yang sama. AI Perfumer tidak pernah menghasilkan formula PERSONA resmi.",
    p5_form_name: "Nama lengkap",
    p5_form_dob: "Tanggal lahir",
    p5_form_blood: "Golongan darah",
    p5_form_gender: "Jenis kelamin",
    p5_form_path: "Jalur ekspresi wewangian",
    p5_form_submit: "Hitung PERSONA Research",
    p5_form_computing: "Menghitung…",

    p5_research_title: "Riset Saya",
    p5_research_sub: "Rekaman riset PERSONA Core Anda — immutable dan berversi.",
    p5_research_empty: "Belum ada riset. Mulai dengan PERSONA Perfumery Tech.",
    p5_research_view: "Lihat",
    p5_research_redeem: "Tebus formula resmi (−50 PTC)",
    p5_research_redeemed: "Formula ditebus",

    p5_research_detail: "Detail Riset",
    p5_research_normalized: "Identitas ternormalisasi",
    p5_research_versions: "Versi",
    p5_research_formula_vector: "Vektor formula",
    p5_research_character: "Hasil karakter",
    p5_research_fingerprint: "Fingerprint kanonik",

    p5_ptc_title: "Dompet PTC",
    p5_ptc_sub: "PERSONA Tech Credit — ledger loyalitas ekosistem append-only.",
    p5_ptc_balance: "Saldo",
    p5_ptc_txns: "Transaksi",
    p5_ptc_empty: "Belum ada transaksi.",

    p5_nav_research: "Riset Saya",
    p5_nav_ptc: "Dompet PTC",

    // Build 03B
    p5_fragrance_identity: "Identitas Wewangian",
    p5_fragrance_identity_sub: "Legacy PERSONA fragrance routing · pemetaan enam-slot teraudit",
    p5_official_formula: "Formula Resmi PERSONA",
    p5_formula_total: "Total",
    p5_formula_locked: "Menunggu penebusan",
    p5_status_verified: "Terverifikasi",
    p5_status_verified_legacy: "Referensi PERSONA warisan",
    p5_status_review_required: "Klasifikasi profesional tertunda",
    p5_pyramid_pending: "Aroma warisan — klasifikasi profesional tertunda",
    p5_repeat_notice: "Anda sudah memiliki riset dengan identitas yang sama persis. Membuka rekaman yang ada.",
    p5_month_character: "Karakter bulan lahir",
    p5_name_character: "Karakter nama",
    p5_new_research: "Riset Baru",

    // Build 04
    p5_ai_title: "PERSONA AI Perfumer",
    p5_ai_subtitle: "Minta AI menafsirkan riset ini",
    p5_ai_disclaimer: "Hanya penafsiran AI. Formula Resmi PERSONA hanya dihasilkan oleh PERSONA Core — bukan oleh AI.",
    p5_ai_cta: "Tanya PERSONA AI Perfumer",
    p5_ai_regenerate: "Buat Ulang",
    p5_ai_generating: "PERSONA AI Perfumer sedang menyusun penafsiran…",
    p5_ai_done: "Penafsiran AI siap",
    p5_ai_unavailable: "PERSONA AI Perfumer sementara tidak tersedia.",
    p5_ai_summary: "Identitas Wewangian Anda",
    p5_ai_character: "Penafsiran Karakter",
    p5_ai_identity: "Arah Wewangian",
    p5_ai_pyramid: "Penafsiran Pyramid",
    p5_ai_mood: "Suasana Wangi",
    p5_ai_wearing: "Kapan Memakai",
    p5_ai_perfumer_note: "Catatan Perfumer",
    p5_ai_limitations: "Status Data",
    p5_ai_footer: "Penafsiran AI",
    p5_ai_cached: "tersimpan",
    p5_ai_fresh: "baru",

    // Build 05
    p5_research_pyramid: "Piramida Wewangian",
    p5_birth_character: "Karakter tanggal lahir",
    p5_research_not_found: "Riset tidak ditemukan",
    p5_unlock_cta: "Buka Riset Penuh",
    p5_unlock_helper: "Membuka riset penuh menampilkan hasil Formula Resmi PERSONA yang dihasilkan oleh PERSONA Core.",
    p5_unlock_soon: "Fitur buka riset penuh akan segera tersedia.",

    // Corrective pass
    p5_character_profile: "Profil Karakter",
    p5_character_profile_empty: "Profil karakter belum tersedia.",
    p5_pyramid_pending: "Klasifikasi menunggu",
    p5_pyramid_pending_hint: "Posisi olfaktori profesional untuk aroma warisan ini masih menunggu klasifikasi.",
  },
  fr: {
    p5_platform: "Plateforme intelligente de technologie olfactive",
    p5_build: "Build 01 · Fondation",

    p5_pt_title: "PERSONA Perfumery Tech",
    p5_pt_sub: "Découvrez votre identité olfactive via le moteur déterministe PERSONA Core.",
    p5_pt_disclaimer:
      "PERSONA Core est un moteur déterministe — identité + versions identiques produisent toujours le même résultat canonique. L'AI Perfumer ne génère jamais la formule PERSONA officielle.",
    p5_form_name: "Nom complet",
    p5_form_dob: "Date de naissance",
    p5_form_blood: "Groupe sanguin",
    p5_form_gender: "Genre",
    p5_form_path: "Chemin d'expression olfactive",
    p5_form_submit: "Calculer la recherche PERSONA",
    p5_form_computing: "Calcul en cours…",

    p5_research_title: "Mes recherches",
    p5_research_sub: "Vos recherches PERSONA Core — immuables et versionnées.",
    p5_research_empty: "Aucune recherche pour l'instant.",
    p5_research_view: "Voir",
    p5_research_redeem: "Récupérer la formule officielle (−50 PTC)",
    p5_research_redeemed: "Formule récupérée",

    p5_research_detail: "Détail de la recherche",
    p5_research_normalized: "Identité normalisée",
    p5_research_versions: "Versions",
    p5_research_formula_vector: "Vecteur de formule",
    p5_research_character: "Résultat de caractère",
    p5_research_fingerprint: "Empreinte canonique",

    p5_ptc_title: "Portefeuille PTC",
    p5_ptc_sub: "PERSONA Tech Credit — registre de fidélité en append-only.",
    p5_ptc_balance: "Solde",
    p5_ptc_txns: "Transactions",
    p5_ptc_empty: "Aucune transaction.",

    p5_nav_research: "Mes recherches",
    p5_nav_ptc: "Portefeuille PTC",

    // Build 03B
    p5_fragrance_identity: "Identité olfactive",
    p5_fragrance_identity_sub: "Routage historique PERSONA · mappage à six emplacements audité",
    p5_official_formula: "Formule PERSONA officielle",
    p5_formula_total: "Total",
    p5_formula_locked: "En attente de récupération",
    p5_status_verified: "Vérifié",
    p5_status_verified_legacy: "Référence PERSONA historique",
    p5_status_review_required: "Classification professionnelle en attente",
    p5_pyramid_pending: "Arôme historique — classification professionnelle en attente",
    p5_repeat_notice: "Vous avez déjà une recherche avec cette identité exacte. Ouverture de l'enregistrement existant.",
    p5_month_character: "Caractère du mois de naissance",
    p5_name_character: "Caractère du nom",
    p5_new_research: "Nouvelle recherche",

    // Build 04
    p5_ai_title: "PERSONA AI Perfumer",
    p5_ai_subtitle: "Demandez à l'IA d'interpréter cette recherche",
    p5_ai_disclaimer: "Interprétation IA uniquement. La Formule PERSONA Officielle est générée exclusivement par PERSONA Core — jamais par l'IA.",
    p5_ai_cta: "Demander à PERSONA AI Perfumer",
    p5_ai_regenerate: "Régénérer",
    p5_ai_generating: "PERSONA AI Perfumer compose votre interprétation…",
    p5_ai_done: "Interprétation IA prête",
    p5_ai_unavailable: "PERSONA AI Perfumer est temporairement indisponible.",
    p5_ai_summary: "Votre identité olfactive",
    p5_ai_character: "Interprétation du caractère",
    p5_ai_identity: "Direction olfactive",
    p5_ai_pyramid: "Interprétation de la pyramide",
    p5_ai_mood: "Ambiance olfactive",
    p5_ai_wearing: "Quand la porter",
    p5_ai_perfumer_note: "Note du parfumeur",
    p5_ai_limitations: "Statut des données",
    p5_ai_footer: "Interprétation IA",
    p5_ai_cached: "en cache",
    p5_ai_fresh: "récent",

    // Build 05
    p5_research_pyramid: "Pyramide olfactive",
    p5_birth_character: "Caractère de la date de naissance",
    p5_research_not_found: "Recherche introuvable",
    p5_unlock_cta: "Débloquer la recherche complète",
    p5_unlock_helper: "Le déverrouillage révèle le résultat de la Formule PERSONA Officielle générée par PERSONA Core.",
    p5_unlock_soon: "Le déblocage complet sera bientôt disponible.",

    // Corrective pass
    p5_character_profile: "Profil de caractère",
    p5_character_profile_empty: "Profil de caractère en attente.",
    p5_pyramid_pending: "Classification en attente",
    p5_pyramid_pending_hint: "La position olfactive professionnelle de ces arômes historiques reste à classer.",
  },
};

export default P5;
